import { types } from '../../types/types';

const FOCUS_TTL_MS = 10000;

const initialState = {
    focusedByContact: {}, // { [id_contact]: { [email]: { displayName, lastAt } } }
};

const now = () => Date.now();

const pruneContact = (byEmail) => {
    const cutoff = now() - FOCUS_TTL_MS;
    return Object.keys(byEmail).reduce((acc, email) => {
        if (byEmail[email].lastAt >= cutoff) acc[email] = byEmail[email];
        return acc;
    }, {});
};

export const focusReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.focusSet: {
            const { id_contact, email, displayName, lastAt } = action.payload;
            if (!id_contact || !email) return state;

            const byContact = { ...state.focusedByContact };
            const byEmail = {
                ...pruneContact(byContact[id_contact] || {}),
                [email]: { displayName, lastAt: lastAt || now() },
            };
            byContact[id_contact] = byEmail;

            return { ...state, focusedByContact: byContact };
        }

        case types.focusClear: {
            const { id_contact, email } = action.payload;
            if (!id_contact) return state;

            const byContact = { ...state.focusedByContact };

            // Sin email → limpiar todo el contacto
            if (!email) {
                delete byContact[id_contact];
                return { ...state, focusedByContact: byContact };
            }

            const byEmail = pruneContact(byContact[id_contact] || {});
            delete byEmail[email];

            if (Object.keys(byEmail).length === 0) {
                delete byContact[id_contact];
            } else {
                byContact[id_contact] = byEmail;
            }

            return { ...state, focusedByContact: byContact };
        }

        case types.focusPrune: {
            const byContact = state.focusedByContact;
            const next = {};
            let changed = false;

            Object.keys(byContact).forEach((id_contact) => {
                const original = byContact[id_contact];
                const pruned = pruneContact(original);
                if (Object.keys(pruned).length === 0) {
                    changed = true; // contacto sin focus fresco → se elimina
                    return;
                }
                if (Object.keys(pruned).length !== Object.keys(original).length) {
                    changed = true;
                }
                next[id_contact] = pruned;
            });

            return changed ? { ...state, focusedByContact: next } : state;
        }

        default:
            return state;
    }
};
